<template>
<!-- Una pagina dedicata alla presentazione dei docuemnti da poter scaricare -->
  <div>
    <PageTagline :elements="tagline_elem"/>

    <!-- Tutorial contestuale per gli argomenti del form. Vengono passati gli slug name dei video da mostrare -->
    <TutorialContestuale :video_to_show="['area_informazioni']"/>

    <!-- CARD PER CONTENERE GLI ACCORDION DEI GRUPPI DI DOCUMENTI -->
    <b-card no-body class="mr-1 ml-1">
      <b-card-header>
        <h4><b-icon icon="file-earmark-text" font-scale="1.5"></b-icon> Documentazione</h4>
      </b-card-header>
      <b-card-body>
        <p class="text-justify">In questa sezione troverai la documentazione relativa ai servizi offerti da Welfarebit.</p>
        <p class="text-justify">Clicca sulla sezione di tuo interesse per visualizzare i documenti disponibili.</p>
        <!-- TESTO DI DEFAULT SE NON CI SONO ELEMENTI -->
        <h5 class="text-center" v-if="items.length === 0">Nessun documento disponibile.</h5>
        <!-- ACCORDION - UNO PER OGNI GRUPPO DI DOCUMENTI -->
        <!-- Nota bene: il gruppo viene visualizzato solo se popolato con almeno un link -->
        <b-card no-body class="mb-1" v-for="group in items" :key="group.id">
          <!-- Header dell'accordion con il pulsante di apertura -->
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block class="accordion-btn" v-b-toggle="'accordion-' + group.id" :style="customer_styles.accordion_button">
              {{group.nome}}
              <!-- La visibilità delle due icone per visualizzare lo stato di aperto e chiuso -->
              <!-- è gestita tramite css, vedi sotto. -->
              <b-icon class="close-arrow" icon="chevron-right"></b-icon>
              <b-icon class="open-arrow" icon="chevron-down"></b-icon>
            </b-button>
          </b-card-header>
          <!-- CONTENUTO ACCORDION -->
          <!-- Elemento collapse che contiene il contenuto dell'accordion ( il card-body ) -->
          <!-- il suo id deve corrispondere con quello della proprietà v-b-toggle del pulsante -->
          <!-- che lo apre. -->
          <b-collapse :id="'accordion-' + group.id" :visible="set_visible_on_group_to_show" accordion="accordion-group" role="tabpanel">
            <b-card-body>
              <!-- LINK AI DOCUMENTI CONTENUTI IN OGNI GRUPPO -->
              <b-row class="mb-4">
                <b-col cols=6><b>Argomento</b></b-col>
                <b-col cols=6><b>Scarica il contenuto</b></b-col>
              </b-row>
              <b-row class="mb-1 pb-2 pt-2 link-row" v-for="link in group.link" :key="link.id">
                <b-col cols=6>{{link.descrizione}}</b-col>
                <b-col cols=6>
                  <b-link target="_blank" :href="link.url"><b-icon icon="cloud-download"></b-icon>  {{link.nome}}</b-link>
                </b-col>
              </b-row>
            </b-card-body>
          </b-collapse>
        </b-card>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import TutorialContestuale from '@/components/TutorialContestuale'
import { generalLib } from '@/generalLib'
import { customerStylesMixin } from '@/mixins/customerStylesMixin'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
  name: 'DocumentazioneView',
  mixins: [ customerStylesMixin ],
  data () {
    return {
      // Variabili generali
      tagline_elem : [ { text : "Documentazione", link : 'documentazione' } ],

      // Elementi tornati dalla chiamata, i link divisi per gruppi
      items : []
    }
  },
  computed : {
    /**
     * Usata per mostrare già aperto l'accordion del gruppo
     * passato come prop dal router quando si vogliono mostrare solo
     * gli elemento di un gruppo specifico.
     * Torna quindi true se è stata passata la prop group_to_show
     * e se ci sono elementi da visualizzare per lo specifico gruppo.
     */
    set_visible_on_group_to_show : function () {
      return this.items.length > 0 && this.group_to_show != null ? true : false;
    }
  },
  created : function () {
    /**
     * Alla creazione dell'elemento popoliamo l'array items con gli elementi
     * per popolare gli accordion nella pagina.
     */
    let api_url = apiUrl.staticlinks.list_links.replace( '@ltype', 'documentazione' );
    axios.get( api_url )
    .then( ( response ) => {
      if ( this.group_to_show === null ) {
        // Se la property group_to_show è null mostriamo tutta la lista divisa per gruppi
        // prendendo però solo quelli che hanno al loro interno almeno un link
        this.items = response.data.filter( ( elem ) => { return elem.link.length > 0 });
      } else {
        // Altrimenti prendiamo solo il gruppo indicato dalla group_to_show
        // e visualizzeremo solo quello. Sempre se dentro c'è almeno un link disponibile
        this.items = response.data.filter( ( elem ) => {
          return elem.slug_name === this.group_to_show && elem.link.length > 0
        });
      }
    })
    .catch( ( error ) => {
      generalLib.backend_error_message_box( this, error.response.data );
    });
  },
  props : {
    /**
    * Prop che è passata dal router, se valorizzata indica che deve essere visualizzata
    * solo la documentazione appartenente a questo specifico gruppo.
    */
    group_to_show: {
      type: String,
      default : null
    }
  },
  components : {
    PageTagline,
    TutorialContestuale
  }
}
</script>

<style scoped>
/* COLORAZIONE DEI BOTTONI CHE APRONO GLI ACCORDION */
/* Dati i selettori per i bottoni per poter iniettare al suo interno una variabile
   che definisca il colore presa dalla mappatura nella skin usiamo la tecnica delle variabili css.
   Nell'oggetto della skin sono definite le tre variabili --background-color, --text-color
   e --border-color, le quali sono passate tramite l'attributo "style" dei bottoni,
   al css qui sotto, il css legge il valore definito nella variabile e lo applica.
   Se la variabile non è trovata si utilizzano i colori di default originali definiti
   in bootstrap per i bottoni, i quali sono scritti vicini alle variabili come valore
   alternativo */
.accordion-btn, .accordion-btn:focus, .accordion-btn:hover {
  text-align : left;
  background-color: var(--background-color, #138496 );
  color: var(--text-color, #ffffff );
  border-color: var(--border-color, #117a8b );
}

/* Il bottone di apertura segnala lo stato del relativo
   accordion con le due classi collapsed e not-collapsed
   in base alla presenza di tali classi nascondiamo la giusta
   icona */
.collapsed > .open-arrow {
  display: none;
}
.not-collapsed > .close-arrow {
  display: none;
}

/* Colore della parte sotto delle row dove sono i link
   come seprazione, utile soprattuto in mobile */
.link-row {
  border-bottom: 1px solid #c2c4c3;
}
</style>